const data = [
  {
    "letter": "../../static/img/letters/w.png",
    "jobTitle": "FULL STACK WEB DEVELOPER",
    "description": "We are searching for an outstanding web developer to be responsible for developing innovative, reusable " +
      "Web-based tools for one of leading projects. Our web developers work closely with our project managers, strategists " +
      "and design team members to develop specifications and make recommendations " +
      "on the use of new and emerging technologies. Programming, graphic design and " +
      "database administration are all elements of this position.",
    "responsibilities": [
      "Work closely with Project Managers and other members of the Development Team to both develop detailed specification documents with clear project deliverables and timelines, and to ensure timely completion of deliverables\n" +
      "Attend client meetings during the sales process and during development",
      "Determine appropriate architecture, and other technical solutions, and make relevant recommendations to clients",
      "Communicate to the Project Manager with efficiency and accuracy any progress and/or delays. Engage in outside-the-box thinking to provide high value-of-service to clients",
      "Alert colleagues to emerging technologies or applications and the opportunities to integrate them into operations and activities",
      "Develop innovative, reusable Web-based tools"
    ],
    "personalSkills": [
      "BS in computer science or a related field, or significant equivalent experience",
      "2+ years Web programming experience, including PHP, ASP or JSP",
      "Development experience using extensible web authoring tools",
      "Experience developing and implementing open source software projects",
      "Self-starter with strong self-management skills",
      "Ability to organize and manage multiple priorities"
    ]
  },
  {
    "letter": "../../static/img/letters/s.png",
    "jobTitle": "SENIOR MOBILE DEVELOPER",
    "description": "We are looking for a senior mobile developer to lead the development and maintenance of " +
      "Android and iPhone apps. The developer will lead the entire app lifecycle right from alpha " +
      "stage until delivery and post launch support. " ,
    "personalSkills": [
      "Proven commercial software development experience – desktop and mobile" +
      "Published examples of mobile applications on the App store or the Android market",
      "Excellent knowledge in information architecture",
      "A track record of delivering successful consumer and or business products",
      "A passion for new consumer technology and the emerging media landscape",
      "Ability to multi task and good time management skills",
      "Ability to work on their own and as a part of the team",
      "Excellent scoping and estimation skills",
      "Excellent testing/ QA skills",
      "Excellent communication skills (verbal and written) to liaise with various departments"
    ],
    "essentialsSkills": [{
      name: "iOS:",
      skills: [
        "Have an In-depth understanding of Swift and Objective-C",
        "Familiar with iOS SDK (UIKit, Cocoa Touch, Core Data, Core Location, etc)",
        "You have experience writing multi-threaded, asynchronous code",
        "Proficient in GUI programming and multithreaded applications",
        "Great blend of independence and team work abilities."
      ]
    },{
      name: "Android:",
      skills: [
        "Solid understanding of the full mobile development life cycle & Android apps distribution process",
        "Knowledge & interest in the mobile development scene, trends & emerging technologies",
        "Strong knowledge of Android UI design principles, patterns, and best practices",
        "Knowledge of SQLite, MySQL or similar database management system",
      ]
    }]
  }
]

export default data;



// WEBPACK FOOTER //
// ./src/jobsData.js